var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertsInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248.0 248.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,2028 L0,2028 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,0 C105.555363,0 136,30.444637 136,68 C136,105.555363 105.555363,136 68,136 C30.444637,136 0,105.555363 0,68 C0,30.444637 30.444637,0 68,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C77.6142375,0 100,4.4771525 100,10 C100,15.5228475 77.6142375,20 50,20 C22.3857625,20 0,15.5228475 0,10 C0,4.4771525 22.3857625,0 50,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9103139,0 C83.5599403,1.2617747 86.3847535,5.400177 86.3847535,12.4152069 L86.3847535,101.724138 L29.5802968,101.724138 L29.5802968,108.635488 C27.6949955,114.878496 24.2504049,118 19.246525,118 C14.2426452,118 10.8579681,114.878496 9.09249369,108.635488 C8.78742208,59.2548173 8.62878484,29.1291686 8.61658197,18.2585418 L8.61600997,17.6041992 C8.61588285,17.3944423 8.6158193,17.1930425 8.6158193,17 C8.6158193,7.34787326 5.74387953,1.6812066 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1724138,0 C15.7933717,0 19.0314123,3.11864217 19.8865356,9.35592651 L19.8865356,16.2758621 L0,16.2758621 L0,9.35592651 C1.16065131,3.11864217 4.55145591,0 10.1724138,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13793103,0 L85.4482759,0.451475472 L85.4482759,7.94120631 C84.0418699,13.4976435 80.9265609,16.2758621 76.1023489,16.2758621 L0,16.2758621 C5.42528736,13.7727018 8.13793103,10.9944832 8.13793103,7.94120631 L8.13793103,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.423061,0 C59.423061,6.63810442 58.2600909,12.9017771 56.2168343,18.8480507 L41.0015154,27.3657529 L52.4650778,27.3657529 C42.6157873,47.203196 22.2179364,58.1980989 0,58.1980989 C0,25.9845709 27.2070533,0 59.423061,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.0 -341.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 197.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0 144.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.0 56.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 136,0 136,136 0,136 0,0",
    stroke: "none",
    fill: "#FFF3DB"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.0 212.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 100,0 100,20 0,20 0,0",
    stroke: "none",
    fill: "#F1F2F4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.0 65.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.270716349283823 9.094947017729282e-12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 86.3847535,0 86.3847535,118 0,118 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.8865356,0 19.8865356,16.2758621 0,16.2758621 0,0",
    stroke: "none",
    fill: "#F1F2F4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.55172413793099 101.7241379310362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 85.4482759,0 85.4482759,16.2758621 0,16.2758621 0,0",
    stroke: "none",
    fill: "#F1F2F4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.172413793103374 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L77.0255172,0 L77.3103448,0 C82.9295862,0 87.4827586,4.55317241 87.4827586,10.1724138 L87.4827586,46.02 M87.4827586,101.724138 L87.4827586,46.02",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.5172414,118 L107.738069,118 L107.827586,118 C113.446828,118 118,113.446828 118,107.827586 L118,101.724138 L40.6896552,101.724138 L40.6896552,107.827586 C40.6896552,113.446828 36.1364828,118 30.5172414,118 C24.898,118 20.3448276,113.446828 20.3448276,107.827586 L20.3448276,10.261931 C20.3448276,4.59386207 15.8404828,0 10.1724138,0 L10.2171724,0 C4.54910345,0 0,4.59386207 0,10.261931 L0,16.2758621 L20.3448276,16.2758621",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.75862068965523 20.34482758620652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L24.4137931,0",
    stroke: "#FFD67E",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.551724137931046 36.6206896551721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L48.8275862,0",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.55172413793106 47.89655172413768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L40.6896552,0",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.55172413793099 59.1034482758605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L32.5517241,0",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.0 82.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.529301556687873 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 59.423061,0 59.423061,58.1980989 0,58.1980989 0,0",
    stroke: "none",
    fill: "#25D086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.0015154,27.3657529 L56.2168343,18.8480507 C58.2600909,12.9017771 59.423061,6.63810442 59.423061,0 C27.2070533,0 0,25.9845709 0,58.1980989 C22.2179364,58.1980989 42.6157873,47.203196 52.4650778,27.3657529 L41.0015154,27.3657529 Z",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 33.86003581760599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.1399642 C6.1099325,24.5166001 14.9251963,12.9588098 27.6310787,0",
    stroke: "#16243C",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertsInfoIcon);
export default __webpack_public_path__ + "static/media/experts-info-icon.ea9809c67c9ebd45545697bdcefec86f.svg";
export { ForwardRef as ReactComponent };